/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  AdminState,
  UsersResponse,
  UsersRequest,
  ChangeRoleRequest,
  UpdateUserRequest,
  User,
  OkResponse,
  VerdictRequest,
  OnlyId,
} from 'store/types';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store/store';
import { adminAPI } from 'api/Api';
import { CustomError } from 'store/types';
import omit from 'lodash-es/omit';

export const getUsers = createAsyncThunk<
  UsersResponse,
  UsersRequest,
  { rejectValue: CustomError<Boolean> }
>('admin/getUsers', async (args, { rejectWithValue }) => {
  try {
    const response = await adminAPI.getUsers(args);

    return response;
  } catch (err: any) {
    return rejectWithValue({
      status: err?.response?.status,
    });
  }
});

export const sendVerdict = createAsyncThunk<
  User | OkResponse,
  VerdictRequest,
  { rejectValue: CustomError<Boolean> }
>('admin/sendVerdict', async (args, { rejectWithValue }) => {
  try {
    if (args.verdict) {
      return await adminAPI.activateUser(args);
    } else {
      return await adminAPI.deleteUser(args);
    }
  } catch (err: any) {
    return rejectWithValue({
      status: err?.response?.status,
    });
  }
});

export const changeRole = createAsyncThunk<
  User,
  ChangeRoleRequest,
  { rejectValue: CustomError<Boolean> }
>('admin/changeRole', async (args, { rejectWithValue }) => {
  try {
    const response = await adminAPI.changeRole(args);

    return response;
  } catch (err: any) {
    return rejectWithValue({
      status: err?.response?.status,
    });
  }
});

export const deleteUser = createAsyncThunk<
  OkResponse,
  OnlyId,
  { rejectValue: CustomError<Boolean> }
>('admin/deleteUser', async (args, { rejectWithValue }) => {
  try {
    const response = await adminAPI.deleteUser(args);

    return response;
  } catch (err: any) {
    return rejectWithValue({
      status: err?.response?.status,
    });
  }
});

const initialState: AdminState = {
  globalLoadingCounter: 0,
  users: null,
  isVerdictPending: false,
  result: null,
  pendingVerdicts: {} as { [x: string]: UpdateUserRequest },
  total: null,
  error: null,
  isResultFrozen: false,
};

export const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    dropResult: (state) => {
      state.result = null;
    },
    // Решение проблемы мигания при переходе между existing/requests.
    dropResponse: (state) => {
      state.users = null;
      state.total = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUsers.pending, (state) => {
      state.result = null;
      state.globalLoadingCounter += 1;
    });
    builder.addCase(getUsers.fulfilled, (state, { payload }) => {
      state.users = payload.data;
      state.total = payload.total;
      state.globalLoadingCounter -= 1;
    });
    builder.addCase(getUsers.rejected, (state) => {
      state.globalLoadingCounter -= 1;
      state.result = {
        type: 'error',
        message: 'Упс, кажется что то пошло не так',
      };
    });

    builder.addCase(sendVerdict.pending, (state, { meta }) => {
      state.result = null;
      state.isVerdictPending = true;
      state.pendingVerdicts[meta.arg._id] = meta.arg;
    });
    builder.addCase(sendVerdict.fulfilled, (state, { meta }) => {
      state.users = {
        ...omit(state.users, meta.arg._id),
      };
      state.isVerdictPending = false;
      state.pendingVerdicts = omit(state.pendingVerdicts, meta.arg._id);
    });
    builder.addCase(sendVerdict.rejected, (state, { meta }) => {
      state.isVerdictPending = false;
      state.pendingVerdicts = omit(state.pendingVerdicts, meta.arg._id);

      state.result = {
        type: 'error',
        message: 'Не удалось изменить статус заявки',
      };
    });

    builder.addCase(changeRole.pending, (state) => {
      state.result = null;
    });
    builder.addCase(changeRole.fulfilled, (state, { meta }) => {
      if (state?.users?.[meta.arg._id]) {
        state.users[meta.arg._id].role = meta.arg.role;
      }
    });
    builder.addCase(changeRole.rejected, (state) => {
      state.result = {
        type: 'error',
        message: 'Упс, кажется что то пошло не так',
      };
    });

    builder.addCase(deleteUser.pending, (state) => {
      state.result = null;
    });
    builder.addCase(deleteUser.fulfilled, (state, { meta }) => {
      if (state?.users?.[meta.arg._id]) {
        state.users = omit(state.users, meta.arg._id);
      }
    });
    builder.addCase(deleteUser.rejected, (state) => {
      state.result = {
        type: 'error',
        message: 'Упс, кажется что то пошло не так',
      };
    });
  },
});

export const { dropResult, dropResponse } = adminSlice.actions;

export const selectUsers = (state: RootState) => state.admin.users;
export const selectIsVerdictPending = (state: RootState) =>
  state.admin.isVerdictPending;
export const selectPendingVerdict = (state: RootState) =>
  state.admin.pendingVerdicts;
export const selectResult = (state: RootState) => state.admin.result;
export const selectTotal = (state: RootState) => state.admin.total;

export default adminSlice.reducer;
